module.exports = __webpack_public_path__ + "static/poster-desk-ef9140e66b5d7ac7a426a00f97e6d15d.jpg";